<template>
	<div class="growth-article">
		<article class="column">
			<div class="title-wrap">
				<h3>
					経営陣のコミットメント
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/growth_as_an_engineer/image01.jpg" alt="" />
			</div>
			<div class="content">
				<div class="content-inner infigure">
					<p class="content-catch">
						経営ボードのミッションは、<br />
						技術者が成長できる環境を提供し続けること。
					</p>
					<div class="message-text">
						<p>
							「私が一番大事にしているのは、<br />
							豆蔵が技術のプロフェッショナル集団であること。<br />
							経営ボードとしては、現場の技術者が成長できる環境を提供し続けなければならない。<br />
							その優先順位が最も高いですし、今後も変わることはないでしょう」<br />
							<span class="name">
								代表取締役社長 中原 徹也
							</span>
						</p>
						<p>
							「会社が成長して、エンジニアの数が増えることによって、<br />
							技術力が薄まるようには絶対にしたくない。<br />
							個人個人が強みを発揮できる環境をつくって、<br />
							技術力の多様化を進め、常に周りから学べるようにしていきたい」<br />
							<span class="name">
								取締役 福富 三雄
							</span>
						</p>
					</div>
					<div class="content-text">
						<p class="content-text-inner-catch">創業以来、豆蔵の成長の源泉は、<br />「技術力」と明確に定義している</p>
						<p>
							「強い個性と技術力を持った集団」にしていくことが最も大切、と社長の中原は語ります。「技術者には、豆蔵という会社を利用して成長して欲しいのです。そのために経営や営業は、技術者が能力を発揮できるプロジェクトを、受注することを心がけています。会社の売上目標を達成するためだけに、プロジェクトを受注するのではなく、技術者の成長を常に見据える。その方が、クライアントにとっても、中長期的に良い結果が出やすいので、創業以来、このスタンスは変えていません」。
						</p>
						<p class="content-text-inner-catch">
							エンジニアファーストな評価制度で、<br />定年まで技術者として成長できる
						</p>
						<p>
							豆蔵は、クラスランクという指標を用いてエンジニアを評価します。
						</p>
					</div>
					<div class="image">
						<img src="../../assets/growth_as_an_engineer/commitment_figure.jpg" alt="" />
					</div>
					<div class="content-text">
						<p>
							クラスランクはⅠ－1からⅥまであり、Ⅳ以上においては、①コンサルタント②エキスパート③マネジメントの３つからキャリアを自分で選択できます。<br />
							<br />
							一度選択したらずっと同じキャリアを継続するのではなく、ご意向に応じてキャリアチェンジが可能です。「マネジメントもやりつつ、コンサルタントとしてのキャリアも積みたい」といったカスタマイズもできます。<br />
							<br />
							どのキャリアを選んでも給与体系に差はなく、例えば「マネジメントとしてのキャリアを積まないと給与が上がらない」ということはありません。同じクラスランクであれば、どのキャリアを選んでも給与は同じになります。豆蔵の成長の源泉は、「技術力」と明確に定義しているからこそ、このような技術者としてのスキルを重視する評価制度を設けているのです。<br />
							<br />
							「さらに、豆蔵は、『エキスパート職』というキャリアパスを用意しています。部下を持って役職者として上がっていくキャリアだけでなく、定年まで技術者として活躍できる道をつくりました。エキスパートは、深く、そして幅広く技術を追求するだけではありません。クライアントが求めている課題に対してどの技術を提供するのか、その判断ロジックを高いレベルで保持している技術者を指します。ここまで特化したポジションを用意している会社は、同業では珍しいと思います」と社長の中原。加えて、エキスパート職のベテランと若手が組んでプロジェクトを担うことで、若手の成長が促進されています。単に技術力の向上に留まらず、技術者としての人間力も鍛えられます。だからこそ、豆蔵は高次の問題解決ができる人材を育成できているのです。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column">
			<div class="title-wrap">
				<h3>
					技術者として成長できる5つの理由
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/growth_as_an_engineer/image02.jpg" alt="" />
			</div>
			<div class="content">
				<div class="content-inner">
					<div class="content-list">
							<h4 class="content-list-head">
								技術力・技術モチベーションが高い社員から、刺激を受けられる
							</h4>
							<div class="content-list-inner">
								<p class="content-list-body">
									豆蔵には、モデリング設計や要求分析、プロセス改善、ロボット開発、データサイエンスなどのエキスパートが在籍しており、専門書の執筆やメディアへの連載経験がある技術者も多くいます。そして、技術者同士が密にやりとりする風土もありますので、分からないことや相談したいことを伝えれば、すぐに答えが返ってきます。「社内の技術者に聞けば、大体の問題は解決できる」と言う社員は多いです。最新技術をキャッチアップするカルチャーも醸成されており、技術談義も盛んに行われています。「自ら新しい技術を学び続けて成長したい」という方には、刺激的な毎日になるでしょう。
								</p>
							</div>
							<h4 class="content-list-head">
								技術発信を積極的に行なう風土
							</h4>
							<div class="content-list-inner">
								<h5 class="content-list-item"><span class="number">&#9312; </span>技術のスペシャリストを招いた、オンラインイベント「豆寄席」の定期開催</h5>
								<p class="content-list-body indent">
									豆蔵として、技術者の学ぶ意欲に応えるために、社内外のスペシャルな講師が講演します。クラウドアーキテクチャの専門書籍の執筆者や、Microsoft Azureの機能実装の責任者、LINEのテストコンサルティングの指導者など、多彩な講師を招聘。豆蔵の技術力の高さが認められているからこそ、多くの著名な技術者に講師を引き受けていただくことができるのです。豆蔵のコンサルタントもアジャイル開発、データ分析、ソフトウェア工学、ロボット開発、テスト設計等、得意領域についての講演を多数行なっています。<br />
									参考情報：<a href="https://mamezou.connpass.com/" target="_blank" class="underline">豆寄席</a>
								</p>
								<h5 class="content-list-item"><span class="number">&#9313; </span>技術ブログと技術情報記事の発信</h5>
								<p class="content-list-body indent">
									技術ブログの「<a href="https://developer.mamezou-tech.com/" target="_blank" class="underline">豆蔵デベロッパーサイト</a>」やメインサイトの「<a href="https://www.mamezou.com/techinfo" target="_blank" class="underline">技術情報</a>」では、社員が最先端の技術的知見を発信しています。この技術発信は手を挙げれば誰でも参加が可能で、インプットした情報を気軽にアウトプットする場として提供しています。
								</p>
								<h5 class="content-list-item"><span class="number">&#9314; </span>書籍を多数執筆</h5>
								<p class="content-list-body indent">
									豆蔵が得意とするモデリングやエンジニアリングに関する書籍を中心として、豆蔵のコンサルタントは多数の書籍を出版しています。世の中に最新の技術を提供できる、業界でも有名なコンサルタントから常に刺激を受けながら成長できます。<br />
									参考情報：<a href="https://www.mamezou.com/book" target="_blank" class="underline">豆蔵社員・関係者の本</a>
								</p>
								<h5 class="content-list-item"><span class="number">&#9315; </span>ITセミナー・イベントへの登壇</h5>
								<p class="content-list-body indent">
									文字での技術発信のみならず、ITセミナーやイベントへの登壇も積極的に行なっています。過去には、豆蔵が取り組んでいる産学連携教育の推進に知己のある大学教授の講演や各界を代表する有識者による講演など、多彩なプログラムを設けた『豆蔵DX day』というリアルイベントを実施したこともあります。<br />
									※社員のセミナー・イベント登壇情報は、メインサイトの<a href="https://www.mamezou.com/news" target="_blank" class="underline">ニュース</a>から確認できます。
								</p>
								<h5 class="content-list-item"><span class="number">&#9316; </span>展示会への出展</h5>
								<p class="content-list-body indent">
									展示会への出展も活発に行なっています。ロボット領域では自社オリジナルロボットを用いたデモンストレーションを行ないお客様へ豆蔵が持っている技術価値を発信。その他、板金業界向けプラットフォーム『FANDX』や『レーザ溶接ロボットシステム』、対話型AIエンジン『MZbot』のご提案なども行なっています。
								</p>
							</div>
							<h4 class="content-list-head">
								勉強会・研修の実施
							</h4>
							<div class="content-list-inner">
								<h5 class="content-list-item"><span class="number">&#9312; </span>中途・新入社員向け社内研修</h5>
								<p class="content-list-body indent">
									豆蔵には複数の事業領域があり、それぞれ扱っている技術が異なるため、事業領域に特化した研修は個別に実施しています。それに加え、『豆蔵を知ること』、『豆蔵リベラルアールを学ぶこと』、『業務を円滑に進められるコツを学ぶこと』という豆蔵社員に共通で学んでもらいたいことをまとめた研修も行なっています。
								</p>
								<h5 class="content-list-item"><span class="number">&#9313; </span>特化型研修・勉強会</h5>
								<p class="content-list-body indent">
									要求、アジャイル、テスト、モデリング、DDD等、１つのテーマに特化し行う研修や勉強会を実施しています。ご自身の興味・関心のある研修に参加いただき、スキルを磨いてください。
								</p>
								<h5 class="content-list-item"><span class="number">&#9314; </span>社員が主導で行なうHackathon（ハッカソン）</h5>
								<p class="content-list-body indent">
									リモートワークが中心となった豆蔵では、社員同士のコミュニケーション不足の解消やスキルアップを目的として、Hackathon（ハッカソン）が定期開催されています。Hackathonという名前で開催していますが、一般的なHackathonとは異なり、参加者がそれぞれテーマを決めて、勉強・開発を行います。この活動は社員が自発的に始めたもので、この指止まれで色々な活動が出来る企業文化が根付いています。
								</p>
							</div>
							<h4 class="content-list-head">
								技術のスペシャリストが培った「ノウハウ」「ノウフー」の共有化
							</h4>
							<div class="content-list-inner">
								<h5 class="content-list-item"><span class="number">&#9312; </span>Scrapboxを活用した情報の共有化</h5>
								<p class="content-list-body indent">
									技術に関するノウハウや、各社員が何を得意としているかというノウフーを、一元管理するためのクラウドサービスを全社展開しています。新しい技術を習得するには「体系的な情報のインプット」と「理解した情報のアウトプット」が不可欠です。読み手にとってはインプットの場、書き手にとってはアウトプットの場としてこれらは活用されています。<br />
									参考情報：<a href="https://developer.mamezou-tech.com/blogs/2022/01/05/installing-scrapbox/" target="_blank" class="underline">Scrapboxの社内導入</a>
								</p>
								<h5 class="content-list-item"><span class="number">&#9313; </span>外部向けの教育サービスを自社でも活用できる</h5>
								<p class="content-list-body indent">
									豆蔵の源流は、実は社外エンジニア向けの教育部門です。「人材育成コンサルティング」「顧客別カスタマイズ教育」「標準教育（要求定義〜テスト工程まで、ベースとなる知識を教えるカリキュラム）」の3つのサービスを提供しており、そのノウハウは社員向けの育成にも活用されています。磨き抜かれた様々な教材を、社員は自由に閲覧することが可能です。
								</p>
							</div>
							<h4 class="content-list-head">
								大学との連携プロジェクトで先端技術に触れることができる
							</h4>
							<div class="content-list-inner">
								<p class="content-list-body">
									豆蔵では数多くの大学との連携プロジェクトが立ち上がっています。AI、データサイエンス、ロボティクス、デザイン思考など、その道の研究者と接することで、最先端の研究テーマに直接触れられ、基礎的な技術を習得することができます。既に連携している大学の先生にとどまらず、取り組むテーマによっては、新たな大学の連携先を開拓します。豆蔵社員に向けて大学の先生に講演いただくこともあり、様々な角度から知的好奇心を刺激されることで、技術者としての可能性は広がるでしょう。博士号を取得して豆蔵にジョインし、大学の特任准教授を兼務している社員もいます。アカデミック領域の先端事例に触れながら、自身のスキルをアップデートし続けることができます。
								</p>
							</div>
					</div>
				</div>
			</div>
		</article>

		<article class="column">
			<div class="title-wrap">
				<h3>
					各事業部の技術者の生声
				</h3>
			</div>
			<div class="content">
				<div class="content-inner">
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/shinji.jpg" alt="Shinji" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								プロジェクトの現場で<br />
								切磋琢磨できるアサインを実施
							</p>
							<p class="background">
								Shinji<br />
								ビジネスプラットフォーム領域<br />
								グループリーダー
							</p>
							<p class="voice">
								私がマネジメントを担当している、コールセンターの自動化プロジェクトでは、複数の若手メンバーがジョインしています。得意領域が異なるメンバーをアサインしていて、学び合える環境を意識的に作ることで、成長を促しています。リモート環境での勤務であっても、「一緒に開発を行う仲間」としてコミュニケーションを頻繁に取っているので、モチベーション高く開発業務に携わってくれていますね。
							</p>
						</div>
					</div>
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/tatsuki.jpg" alt="Tatsuki" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								どんなにマニアックな技術的な<br />
								疑問に対しても、必ず誰かが返してくれる
							</p>
							<p class="background">
								Tatsuki<br />
								CTO
							</p>
							<p class="voice">
								豆蔵の社内には、「教え合う空気」が醸成されています。技術的に面白いトピックがあれば、すぐに周りに共有しますし、困っている人がいればすぐに助けるカルチャーが根付いています。全社で技術系の疑問を投稿できる、チャットのスレッドが設置されているのですが、そこに質問を投げると必ずどこからか返信があります。どんなにマニアックな領域でも、社内に対応できる人材がいるので、技術に対する好奇心が満たされる環境です。
							</p>
						</div>
					</div>
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/tadahiro.jpg" alt="Tadahiro" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								15年前の気づきが、<br />
								コンサルタントとしての背骨になっている。
							</p>
							<p class="background">
								Tadahiro<br />
								ビジネスプラットフォーム領域<br />
								グループリーダー
							</p>
							<p class="voice">
								豆蔵に入社して、最初にジョインしたプロジェクトのことは思い出に残っています。社内でも「あの人は凄い」と言われていた先輩コンサルタントに、徹底的に鍛えられましたね。手取り足取り教えてくれるわけではなく、「大人なんだから、自分で考えて自分で学んで。ヒントは与えるけど、答えは自分で見つけてくれ」と言われていました。教えるのではなく、気づかせてくれる育成のスタイルですね。そこで学んだことは、入社後15年が経った今でも、自分のコンサルタントとしての基礎を形成しています。
							</p>
						</div>
					</div>
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/seiji.jpg" alt="Seiji" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								豆蔵のロボット領域では、<br />
								若手でも新規開発案件を手掛けられる
							</p>
							<p class="background">
								Seiji<br />
								ロボット領域<br />
								リーダー
							</p>
							<p class="voice">
								私自身、上流から下流までの全工程を担い、課題の根っ子から考えられるので、コンサルタントとしてのスキルが向上しました。机上の空論ではなく、現場で本当に役に立つ環境や、プロセスをつくり込むスキルを、組織内にも広めていきました。その結果、豆蔵のロボット事業は順調に拡大し、今では自社開発ロボットや大手企業向けの新規案件を手掛けるまでに。新卒・中途入社問わず、若手のロボットエンジニアが急速に成長できる環境が整っています。
							</p>
						</div>
					</div>
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/kazunari.jpg" alt="Kazunari" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								入社5年間でデータサイエンティストとしても、<br />
								コンサルタントとしても、豆蔵を代表する存在に
							</p>
							<p class="background">
								Kazunari<br />
								DX・AIソリューション領域<br />
								コンサルタント
							</p>
							<p class="voice">
								常に最新技術を活用するプロジェクトにアサインされています。大手電機メーカーや金融機関のビッグデータプロジェクトや、RPA導入による業務改善などです。先輩と組んで進めていますが、自分が主体となってクライアントとやりとりを行うことも多いので、成果を直で実感できています。データサイエンティストとしても、コンサルタントとしても、急激に成長している自分を感じていますね。最近では、イベント登壇など、社外の技術者に対して知見を共有する機会も増えています。そのような活動によって、さらに自分のスキルが深まっていくことを実感しています。
							</p>
						</div>
					</div>
					<div class="content-voice">
						<div class="content-voice-image">
							<img src="../../assets/growth_as_an_engineer/shin-nosuke.jpg" alt="Shin-nosuke" />
						</div>
						<div class="content-voice-text">
							<p class="catch">
								大学でのデータサイエンスの研究者と<br />
								企業向けのコンサルタントを兼務
							</p>
							<p class="background">
								Shin-nosuke<br />
								DX・AIソリューション領域<br />
								データサイエンスチーム リーダー
							</p>
							<p class="voice">
								私自身、アメリカや日本でデータサイエンスの研究者として、キャリアを積んできました。ここまで培った知見を、日本企業の変革に活かそうとジョインしたのが豆蔵です。入社して4年が経ちましたが、既に自社製品の開発や、大手企業との「説明可能AI」の研究案件を手掛けています。また、大学の准教授として着任し、研究活動も並行して行うことで、ビジネスとアカデミックの双方の知見を融合。自分自身としても、スキルの幅が広がっていることを実感しています。
							</p>
						</div>
					</div>
					<!-- <p class="attention">※入社年数はインタビュー当時のものです</p> -->
				</div>
			</div>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'growth-article',
};
</script>

<style lang="scss" scoped>
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.growth-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 160px auto 100px;
	@media print, screen and (max-width: 1160px) {
		margin: 100px auto 100px;
	}
	p,a,h3,h4,h5{
    font-weight: 500;
	}
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 140px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
		left: -50%;
	}
	&:nth-child(1) {
		&:after {
			width: 150%;
			top: 0;
			transform-origin: left top;
		}
		&:before {
			width: 100%;
			bottom: 0;
			transform-origin: left top;
			left: -50%;
		}
	}
	&:nth-child(2) {
		&:after {
			width: 150%;
			top: 30%;
			transform-origin: left top;
		}
		&:before {
			width: 100%;
			bottom: -20%;
			transform-origin: left top;
			left: -50%;
		}
	}
	&:nth-child(3) {
		&:after {
			width: 150%;
			top: 60%;
			transform-origin: left top;
		}
		&:before {
			content: none;
		}
	}
}
.title-wrap {
	font-family: 'ots-mincho', serif;
	background-color: #543193;
	color: #fff;
	margin: 0;
	@media print, screen and (min-width: 1161px) {
		position: absolute;
		top: -30px;
		display: inline-block;
	}
	@media print, screen and (max-width: 1160px) {
		font-size: 13px;
		top: 0;
		display: block;
		position: relative;
		padding: 1em 0;
	}
	h3 {
		text-align: center;
		position: relative;
		@media print, screen and (min-width: 1161px) {
			padding: 0 3em;
		}
		@media print, screen and (max-width: 1160px) {
			margin: 0;
		}
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 50px 100px 60px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 20px 5% 50px 5%;
	}
	&.infigure {
		padding: 50px 100px 50px 100px;
		@media print, screen and (max-width: 1160px) {
			padding: 50px 5% 50px 5%;
		}
		.image {
			margin: 20px 0;
		}
	}
}
.content-catch {
	font-size: 26px;
      font-family: 'ots-mincho', serif;
	@media print, screen and (max-width: 1160px) {
		font-size: 18px;
	}
}
//growthのみ
.message-text {
	font-size: 15px;
	position: relative;
	margin: 0 -100px;
	padding: 0 100px;
	&:before {
		@media print, screen and (min-width: 1161px) {
			content: url('../../assets/growth_as_an_engineer/commitment.svg');
			width: 100%;
			position: absolute;
			left: 0;
			z-index: 0;
		}
	}
	p {
		position: relative;
		z-index: 1;
		font-family: 'ots-mincho', serif;
		@media print, screen and (max-width: 1160px) {
			margin: 40px 0;
		}
		&:nth-child(2) {
			@media print, screen and (min-width: 1161px) {
				text-align: right;
				margin-left: 20%;
			}
		}
	}
	.name {
		background: linear-gradient(transparent 50%, #e7e7e7 50%);
		margin-top: 0.7em;
		display: inline-block;
		line-height: 1.8;
	}
}

//growthのみ
.content-list{
	.content-list-head {
		font-family: 'ots-mincho', serif;
		font-size: 22px;
		vertical-align: middle;
		line-height: 2em;
		// display: flex;
		font-weight: 400;
		content: "";
		background-image:url('../../assets/growth_as_an_engineer/circle.svg');
		background-repeat: no-repeat;
    background-size: 40px;
    background-position: 0 3px;
		vertical-align: bottom;
		padding-left: 50px;
		@media print, screen and (max-width: 1160px) {
			background-size: 30px;
			background-position: 0 8px;
			padding-left: 40px;
		}
		}
	&-inner {
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: auto 130px;
		&:not(:last-of-type){
			margin-bottom: 50px;
		}
		&:nth-of-type(1){
				background-image: url('../../assets/growth_as_an_engineer/1.svg');
		}
		&:nth-of-type(2){
				background-image: url('../../assets/growth_as_an_engineer/2.svg');
			}
		&:nth-of-type(3){
				background-image: url('../../assets/growth_as_an_engineer/3.svg');
				}
		&:nth-of-type(4){
				background-image: url('../../assets/growth_as_an_engineer/4.svg');
				}
		&:nth-of-type(5){
				background-image: url('../../assets/growth_as_an_engineer/5.svg');
		}
		.content-list-item{
			font-size: 16px;
			margin: 20px 0 15px;
			font-weight: 400;
			text-indent: -1.3em;
			padding-left: 1.2em;
			letter-spacing: 0.1em;
			.number{
				font-size: 0.9375em;
			}
		}
		.content-list-body {
			font-size: 12px;
			text-align: justify;
			padding: 10px 0;
			margin: -10px 0 20px 0;
			&.indent{
				padding-left:1.75em;
			}
		}
	}
}
//growthのみ
.content-voice {
	display: flex;
	margin-top: 70px;
	@media print, screen and (max-width: 1160px) {
		flex-direction: column;
	}
	&:nth-child(even) {
		@media print, screen and (min-width: 1161px) {
			flex-direction: row-reverse;
		}
		.content-voice-image {
			@media print, screen and (min-width: 1161px) {
				margin-right: 0;
				margin-left: 30px;
			}
		}
	}
	.content-voice-image {
		max-width: 260px;
		width: 100%;
		margin: 0 auto;
		@media print, screen and (min-width: 1161px) {
			margin-right: 30px;
			margin-bottom: 30px;
		}
		@media print, screen and (max-width: 1160px) {
			max-width: 180px;
			margin-bottom: 30px;
		}
	}
	.content-voice-text {
		@media print, screen and (min-width: 1161px) {
			width: calc(100% - 260px);
		}
	}
	.catch {
		font-size: 19px;
		font-family: 'ots-mincho', serif;
		letter-spacing: 0;
		margin-top: -0.5em;
		margin-bottom: 0.5em;
	}
	.background {
		font-size: 12px;
		margin-bottom: 1.5em;
	}
	.voice {
		font-size: 12px;
		text-align: justify;
	}
}
.content-text {
	font-size: 12px;
	text-align: justify;
}
.content-text-inner-catch {
	font-size: 26px;
	font-family: 'ots-mincho', serif;
	margin-top: 70px;
	@media print, screen and (max-width: 1160px) {
		font-size: 18px;
	}
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}
// .attention {
// 	font-size: 14px;
// }
</style>
